let connectionId: string | null = null;

export const setRealtimeConnectionId = (id: string | null) => {
  connectionId = id;
};

export const getRealtimeConnectionId = () => connectionId;
